import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'if_yes_please_describe_2'

export const dataPointDefinition = {
  retracedId: 'if_yes_please_describe_2',
  name: 'If yes, please describe:',
  description: '',
  meta: {
    slcpMeta: {
      key: 'vd-ver-5',
      number: 'VD-VERI-13.1',
      dataType: 'string',
      masterType: 'Follow-up',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: '',
      verificationSelectionOptList: '',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: 'vd-ver-4,Yes',
      machineShowHide: 'vd-ver-4,1',
      completionCondition: '',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'vd-ver-5', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34730,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
